module.exports = __webpack_public_path__ + "media/images/ico-mic-no-dfb49673.svg";